import { Dispatch } from "redux";

import { OwnTasksStateAction } from "@reducers/types/taskManagement/own-tasks-state";

import {
  GET_TM_OWN_TASKS,
  GET_SINGLE_TM_OWN_TASKS,
  CREATE_TM_OWN_TASKS,
  UPDATE_TM_OWN_TASKS,
  DELETE_TM_OWN_TASKS,
} from "./types";
import { OwnTasksCreateType } from "@type/taskManagement/ownTasks";
import {
  fetchOwnTasks,
  fetchOwnTasksById,
  createOwnTasks,
  updateOwnTasks,
  deleteOwnTasks,
} from "@api/taskManagement/ownTasks";

export const ownTasksFetchActionHandler =
  (query: any) => async (dispatch: Dispatch<OwnTasksStateAction>) => {
    dispatch({ type: GET_TM_OWN_TASKS.LOADING, payload: true });

    try {
      const res = await fetchOwnTasks(query);

      const { data, page, size, total } = res.data || {};

      dispatch({
        type: GET_TM_OWN_TASKS.SUCCESS,
        payload: {
          data,
          pagination: {
            page,
            size,
            total,
          },
        },
      });
    } catch (err) {
      dispatch({ type: GET_TM_OWN_TASKS.ERROR, payload: err });
    }
  };

export const ownTasksByIdFetchActionHandler =
  (id: string | number) => async (dispatch: Dispatch<OwnTasksStateAction>) => {
    dispatch({ type: GET_SINGLE_TM_OWN_TASKS.LOADING, payload: true });

    try {
      const res = await fetchOwnTasksById(id);

      dispatch({
        type: GET_SINGLE_TM_OWN_TASKS.SUCCESS,
        payload: res.data || {},
      });
    } catch (err) {
      dispatch({ type: GET_SINGLE_TM_OWN_TASKS.ERROR, payload: err });
    }
  };

export const ownTasksCreateActionHandler =
  (data: OwnTasksCreateType) =>
  async (dispatch: Dispatch<OwnTasksStateAction>) => {
    dispatch({ type: CREATE_TM_OWN_TASKS.LOADING, payload: true });

    try {
      const res = await createOwnTasks(data);

      dispatch({ type: CREATE_TM_OWN_TASKS.SUCCESS, payload: res.data });
    } catch (err) {
      dispatch({ type: CREATE_TM_OWN_TASKS.ERROR, payload: err });
    }
  };

export const ownTasksUpdateActionHandler =
  (id: string | number, data: OwnTasksCreateType) =>
  async (dispatch: Dispatch<OwnTasksStateAction>) => {
    dispatch({ type: UPDATE_TM_OWN_TASKS.LOADING, payload: true });

    try {
      const res = await updateOwnTasks(id, data);

      dispatch({
        type: UPDATE_TM_OWN_TASKS.SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({ type: UPDATE_TM_OWN_TASKS.ERROR, payload: err });
    }
  };

export const ownTasksDeleteActionHandler =
  (id: string | number) => async (dispatch: Dispatch<OwnTasksStateAction>) => {
    dispatch({ type: DELETE_TM_OWN_TASKS.LOADING, payload: true });

    try {
      const res = await deleteOwnTasks(id);

      dispatch({ type: DELETE_TM_OWN_TASKS.SUCCESS, payload: res.data });
    } catch (err) {
      dispatch({ type: DELETE_TM_OWN_TASKS.ERROR, payload: err });
    }
  };
